import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const BetaChip = () => {
  const { t } = useResource();

  return (
    <Chip
      label={t(Resources.Beta.Badge)}
      variant="outlined"
      color="primary"
      size="small"
    />
  );
};
